export const CommonConstants = {
  DisplayScrollTopButtonPaths: [
    "/home",
    "/weddinghall/search",
    "/weddinghall/home",
    "/product/weddinghall",
    "/product/planning",
    "/planners",
    "/planner/portfolios",
    "/partner-list",
    "/product",
  ],
  DisplayWeddingHallQuickButtonPaths: [
    // "/weddinghall/home", // 현재 해당 페이지 접근시 /product/136, /product/1을 iframe으로 띄우고 있음
    "/weddinghall/search",
    "/weddinghall/slot",
    // "/weddinghall/event", // 현재 해당 페이지 접근시 /product/139, /product/5를 iframe으로 띄우고 있음
    "/product/140",
    "/product/141",
    "/product/121",
    "/product/112",
    "/product/113",
    "/product/114",
    "/product/134",
    "/product/136",
    "/product/1",
    "/product/139",
    "/product/5",
    "/booking/real-time/search",  // 즉시예약 검색 페이지에서도 퀵버튼 보여주기
  ],
  DisplaySdmQuickButtonPaths: ["/product/2"],
};
